// src/ApiService/blogApiService.ts

import BaseApiService from "./baseService";

class BlogApiService extends BaseApiService {
  constructor() {
    super("doInsights");
  }

  // listing
  listing(param: object) {
    return this.post("blogs-listing-website", param);
  }

  // create
  create(param: object) {
    return this.post("blogs-create", param);
  }

  // update
  update(param: object) {
    return this.put("blogs-update", param);
  }

  // details
  details(param: object) {
    return this.post("blog-details", param);
  }

  // archive
  archive(param: object) {
    return this.post("blogs-archive", param);
  }

  // upload blog image
  uploadImage(param: FormData) {
    return this.postFileUpload("upload-blog-image", param);
  }
}

const blogServiceObj = new BlogApiService();
export default blogServiceObj;